
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/react-box",
      function () {
        return require("private-next-pages/system/react-box.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/react-box"])
      });
    }
  